import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import classnames from 'classnames';

import {Link} from 'shells/link/link';

import {PageTitleBar} from '../../../layout';

import {EmailSendingSettings} from './email-sending-settings';
import {GetEmailSendingSettings} from './get-email-sending-settings';
import {Unconfigured} from './unconfigured';

import styles from './email-sending-page.module.css';

export function EmailSendingPage() {
    const [isPollTimedOut, setPollTimedOut] = React.useState<boolean>(false);

    const refetchRef = React.useRef<(() => Promise<any>) | null>(null);

    React.useEffect(() => {
        const refetchEmailSendingSettings = () => {
            if (refetchRef.current) {
                refetchRef.current();
            }
        };

        window.addEventListener('email-connected', refetchEmailSendingSettings);

        return () => {
            window.removeEventListener('email-connected', refetchEmailSendingSettings);
        };
    }, []);

    function handlePollTimeout() {
        setPollTimedOut(true);
    }

    return (
        <React.Fragment>
            <PageTitleBar
                title='Email sending settings'
                subheaderPrimaryText='Send email from inside Nutshell'
                buttons={
                    // @ts-expect-error
                    <Link as={RouterLink} variant='button-secondary' size='big' to='/email/inbox'>
                        Inbox
                    </Link>
                }
            />
            <div className={classnames('pad-16', styles['settings-container'])}>
                <GetEmailSendingSettings onVerificationPollTimeout={handlePollTimeout}>
                    {/* @ts-expect-error */}
                    {({isLoading, errorMessage, refetch, configuredUserEmails}) => {
                        refetchRef.current = () => {
                            setPollTimedOut(false);

                            return refetch();
                        };

                        function refetchSettings() {
                            setPollTimedOut(false);

                            return refetch();
                        }

                        if (configuredUserEmails.length) {
                            return (
                                <EmailSendingSettings
                                    configuredUserEmails={configuredUserEmails}
                                    isLoading={isLoading}
                                    isVerificationPollTimedOut={isPollTimedOut}
                                    errorMessage={errorMessage}
                                    refetch={refetchSettings}
                                />
                            );
                        }

                        // Don't flash unconfigured state while loading
                        if (isLoading) return null;

                        return <Unconfigured />;
                    }}
                </GetEmailSendingSettings>
            </div>
        </React.Fragment>
    );
}
